import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const AiChatbotForWebsitePage = () => (
  <SearchLandingPage config={searchLandingPages.aiChatbotForWebsite} />
);

export default AiChatbotForWebsitePage;
